<script setup>
//region Imports
import {onMounted, reactive, ref} from 'vue'
//endregion
//region Methods
const claimsData = () => JSON.parse(localStorage.getItem('tc-claim-claims'))
const claimData = () => JSON.parse(localStorage.getItem('tc-claim-data'))

const addNewClaim = () => {
  location.replace('#/order')
}

const goToClaim = (claim) => {
  localStorage.setItem('tc-claims-selected-claim', JSON.stringify(claim))
  location.replace('#/claims/claim')
}
//endregion
//region Variables
const claims = reactive(claimsData() ?? {})
const data = reactive(claimData() ?? {})
const orderNumber = ref(data?.orderNumber)

//endregion
//region Lifecycle
onMounted(() => {
  if (claims.length > 0) {
    location.replace('#/claims')
  }
})
//endregion
</script>

<template>

  <figure class="w-full h-[305px] overflow-hidden bg-no-repeat bg-right bg-cover"
          style="background-image: url(https://cdn.shopify.com/s/files/1/0067/9532/9609/files/DSC01071.png?v=1713213218);">
    &nbsp;
  </figure>

  <div class="px-[20px] mt-[30px] lg:px-[40px] lg:mt-[37px]">

    <header>

      <h1 class="font-bold text-tc-title font-minionpro text-tc-black tracking-wider"
          v-text="'Resolve Center'"
      ></h1>

      <div class="flex flex-row items-center my-[22px] justify-between">

        <div class="flex gap-4">
          <span class="text-tc-muted-brown text-tc-xl font-avenir">
            Order Number
          </span>
          <span class="text-tc-2xl font-avenir"
                v-text="data?.shopifyOrderId"
          ></span>
        </div>

        <div @click="addNewClaim()"
             :class="{ 'border-black text-red': selectedEntireOrder }"
             class="flex flex-row gap-3 items-center border border-tc-off-white-2 p-2 cursor-pointer font-avenir">
          <figure class="w-[20px] h-[20px] flex justify-center items-center bg-black">
          <span class="block transform text-2xl font-bold text-white animate transition-transform duration-200 ease-in-out"
                :class="{ 'transform rotate-45': selectedEntireOrder }"
          >+</span>
          </figure>
          <span class="text-tc-xl" v-text="selectEntireOrderLabel"
                :class="{ 'text-red': selectedEntireOrder }"
          ></span>
        </div>

      </div>

      <hr class="w-full h-0.5 bg-tc-off-white-two my-[20px] lg:my-[30px]">

    </header>

    <main>
      <h2 class="text-tc-black font-minionpro font-bold leading-relaxed capitalize text-tc-subtitle mb-6"
          v-text="'your claims'"></h2>
      <ul class="grid grid-cols-1 lg:grid-cols-4 gap-12 lg:gap:16 font-avenir">
        <li class="cursor-pointer relative flex"
            v-for="claim in claims" :key="claim.id"
            @click="goToClaim(claim)"
        >
          <div class="relative mr-4 z-1"
               :class="{ 'w-[60px] h-[60px]' : claim?.items?.length > 1, 'w-[50px] h-[50px]': claim?.items?.length === 1 }">
            <span v-if="claim?.items?.length > 1"
                  v-text="claim?.items?.length"
                  class="absolute bg-black rounded-full text-white text-tc-md h-[16px] w-[16px] flex justify-center items-center z-4 -top-1.5 -right-1.5"
            ></span>
            <img :src="claim?.items[0]?.image" class="w-[50px] shadow z-3 absolute top-0 right-0" alt="image" />
            <img v-if="claim?.items?.length > 1" :src="claim?.items[1]?.image ?? claim?.items[0]?.image"
                 class="w-[50px] shadow z-2 absolute top-2 right-2" alt="image"/>
            <img v-if="claim?.items?.length > 2" :src="claim?.items[2]?.image ?? claim?.items[0]?.image"
                 class="w-[50px] shadow z-1 absolute top-4 right-4" alt="image"/>
          </div>

          <div class="flex flex-col justify-center gap-[7px]">
            <span class="text-tc-2xl font-normal text-black tracking-wider leading-tight capitalize">{{ claim?.id }}</span>
            <span class="text-tc-2xl font-normal text-black tracking-wider leading-tight capitalize">{{ claim?.status }}</span>
            <span class="text-tc-xl font-normal tracking-wider text-tc-creme">{{ claim?.updated_at }}</span>
          </div>
        </li>
      </ul>

      <hr class="w-full h-0.5 bg-tc-off-white-two my-[20px] lg:my-[30px]">

      <ul class="grid grid-cols-1 lg:grid-cols-3 gap-4 lg:gap-10 font-avenir" v-if="data != null">
        <li class="flex flex-col gap-1">
          <span class="text-tc-lg text-tc-muted-brown font-medium">Order Number</span>
          <span class="text-tc-lg" v-text="orderNumber ?? 'N/A'"></span>
        </li>
        <li class="flex flex-col gap-1">
          <span class="text-tc-lg text-tc-muted-brown font-medium">Store Order ID</span>
          <span class="text-tc-lg" v-text="data?.shopifyOrderId ?? 'N/A'"></span>
        </li>
        <li class="flex flex-col gap-1">
          <span class="text-tc-lg text-tc-muted-brown font-medium">Order Date</span>
          <span class="text-tc-lg" v-text="data?.orderDate ?? 'N/A'"></span>
        </li>
        <li class="flex flex-col gap-1">
          <span class="text-tc-lg text-tc-muted-brown font-medium">Estimated Delivery Date</span>
          <span class="text-tc-lg" v-text="data?.estimatedDeliveryDate ?? 'N/A'"></span>
        </li>
        <li class="flex flex-col gap-1">
          <span class="text-tc-lg text-tc-muted-brown font-medium">Email</span>
          <span class="text-tc-lg" v-text="data?.customerEmail ?? 'N/A'"></span>
        </li>
        <li class="flex flex-col gap-1">
          <span class="text-tc-lg text-tc-muted-brown font-medium">Shipped To</span>
          <span class="text-tc-lg" v-text="data?.shippingAddress ?? 'N/A'"></span>
        </li>
      </ul>

      <hr class="w-full h-0.5 bg-tc-off-white-two my-[20px] lg:my-[30px]">

      <h3 class="mb-[12px] flex items-center gap-3">
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
          <path
              d="M8.053 6.916H9.067V13H8.053V6.916ZM7.819 4.537C7.819 4.33767 7.88833 4.16433 8.027 4.017C8.17433 3.86967 8.352 3.796 8.56 3.796C8.768 3.796 8.94133 3.86967 9.08 4.017C9.22733 4.16433 9.301 4.33767 9.301 4.537C9.301 4.75367 9.23167 4.93133 9.093 5.07C8.95433 5.20867 8.77667 5.278 8.56 5.278C8.34333 5.278 8.16567 5.20867 8.027 5.07C7.88833 4.93133 7.819 4.75367 7.819 4.537Z"
              fill="#2E1319"/>
          <rect x="0.5" y="0.5" width="16" height="16" rx="8" stroke="#2E1319"/>
        </svg>
        <span class="text-tc-lg text-tc-muted-brown font-medium">Support</span>
      </h3>

      <ul class="grid grid-cols-1 gap-[12px] lg:mb-[30px]">
        <li><a href="https://help.trescolori.com" class="text-tc-lg underline" target="_blank">View Help Center</a></li>
        <li><a href="mailto:info@trescolori.com" class="text-tc-lg underline" target="_blank">info@trescolori.com</a>
        </li>
      </ul>

    </main>

  </div>

</template>

<style scoped>
</style>